import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import blogPosts from '../data/blogPosts';

const BlogPage = () => {
  return (
    <div className="pt-20">
      <Helmet>
        <title>Blog - Strawberry Island | Tofino Adventures, Tips & Guides</title>
        <meta name="description" content="Read our blog for Tofino travel tips, fishing guides, hot springs advice, and island adventure stories. Expert insights from Strawberry Island." />
        <meta name="keywords" content="Tofino blog, fishing blog, travel tips Tofino, hot springs guide, Strawberry Island blog" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative h-[50vh] bg-gradient-to-r from-[#20B2AA] to-[#5DADE2] flex items-center justify-center">
        <div className="relative text-center text-white px-4 z-10">
          <h1 className="text-5xl md:text-6xl brand-script mb-4">
            Strawberry Island Blog 📝
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Travel tips, adventure guides, and island stories from Tofino, BC
          </p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300"
              >
                <Link to={`/blog/${post.slug}`}>
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute top-4 right-4 bg-[#FF69B4] text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {post.category}
                    </div>
                  </div>
                </Link>
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <span>{post.date}</span>
                    <span className="mx-2">•</span>
                    <span>{post.author}</span>
                  </div>
                  <Link to={`/blog/${post.slug}`}>
                    <h2 className="text-2xl font-bold mb-3 hover:text-[#20B2AA] transition-colors" style={{ color: '#20B2AA' }}>
                      {post.title}
                    </h2>
                  </Link>
                  <p className="text-gray-700 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="inline-block text-[#FF69B4] font-semibold hover:text-[#20B2AA] transition-colors"
                  >
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#20B2AA] to-[#FF69B4] text-white">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold mb-6">
            Ready to Experience Strawberry Island?
          </h2>
          <p className="text-xl mb-8">
            Book your fishing charter, cabin stay, or island tour today!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/charters"
              className="bg-white text-[#20B2AA] px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
            >
              Book Fishing Charter 🎣
            </Link>
            <Link
              to="/cabins"
              className="bg-white text-[#FF69B4] px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
            >
              Book Cabin Stay 🏡
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
